'use client'

import { useCallback } from 'react'
import { useRouter } from 'next/navigation'
import type { VisualEditingProps } from 'next-sanity/visual-editing'
import { VisualEditing as NextVisualEditing } from 'next-sanity/visual-editing'

type RefreshHandler = NonNullable<VisualEditingProps['refresh']>

export function VisualEditing() {
  const router = useRouter()

  const refresh = useCallback<RefreshHandler>(
    () =>
      new Promise<void>(resolve => {
        router.refresh()
        setTimeout(resolve, 1000)
      }),
    [router],
  )

  return (
    <NextVisualEditing
      refresh={refresh}
      trailingSlash={true}
    />
  )
}
